import { useTranslation } from 'react-i18next';

import { StaticPageLayout } from '../components/layout/StaticPageLayout';

function Section({
  titleKey,
  children,
}: {
  titleKey: string;
  children: React.ReactNode;
}) {
  const { t } = useTranslation();
  return (
    <section>
      <h2 className="text-xl font-heading font-semibold text-brand-accent mb-3">
        {t(titleKey)}
      </h2>
      <p className="text-neutral-medium font-body leading-relaxed">{children}</p>
    </section>
  );
}

/** Date shown as "last updated" – adjust when you change the terms. */
const TERMS_LAST_UPDATED = '2025-01-01';

export function TermsPage() {
  const { t } = useTranslation();

  return (
    <StaticPageLayout
      titleKey="staticPages.terms.title"
      subtitleKey="staticPages.terms.subtitle"
      lastUpdatedKey="staticPages.terms.lastUpdated"
      date={TERMS_LAST_UPDATED}
    >
      <p className="text-neutral-medium font-body leading-relaxed">
        {t('staticPages.terms.intro')}
      </p>
      <Section titleKey="staticPages.terms.acceptance">
        {t('staticPages.terms.acceptanceText')}
      </Section>
      <Section titleKey="staticPages.terms.service">
        {t('staticPages.terms.serviceText')}
      </Section>
      <Section titleKey="staticPages.terms.account">
        {t('staticPages.terms.accountText')}
      </Section>
      <Section titleKey="staticPages.terms.payment">
        {t('staticPages.terms.paymentText')}
      </Section>
      <p className="text-neutral-medium font-body leading-relaxed pt-2">
        {t('staticPages.terms.contact')}
      </p>
    </StaticPageLayout>
  );
}
